
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Autocomplete, Button, Grid, MenuItem, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { startSavingIngresarProducto, startSavingProducto } from "../../../../services";
import { useProductosTodos } from "../../../../hooks";

import Swal from "sweetalert2";





export const FormIngresarProdBodega = () => {

    
    const { id } = useParams();
    const queryClient = useQueryClient();
    const { productosTodosQuery } = useProductosTodos();


    const [formProducto, setFormProducto] = useState({ producto: '', cantidad: '' });
    const { producto, cantidad } = formProducto;
    const  handleChangeInput = ({ target }) => {
        setFormProducto({ ...formProducto, [target.name]: target.value});
    }



    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([producto, cantidad, id].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }
        await Swal.fire({
            title: `Ingresar Producto`,
            text: `¿Esta seguro de ingresar este producto?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si Ingresar`
        }).then( async( _ ) => {
            const resp = await startSavingIngresarProducto({...formProducto, id});
            if(resp){
                setFormProducto({producto: '', cantidad: ''}); 
                queryClient.invalidateQueries({queryKey: ['inventario-xbodega']});
            }
        });
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12}>
                    <Autocomplete fullWidth size="small"
                        options={productosTodosQuery?.data || []}
                        getOptionLabel={(option) => option?.nombre || ''}
                        value={productosTodosQuery.data?.find(valor => valor.id == producto) || null}
                        onChange={(event, newValue) => {
                            handleChangeInput({
                                target: { name: 'producto', value: newValue ? newValue.id : '' }
                            });
                        }}
                        renderOption={(props, option, { index }) => (
                            <li {...props} key={`${option.id}-${index}`}>
                            {option.nombre}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione Producto" required name="producto" />
                        )}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField required
                        size='small'
                        label='Cantidad'
                        type='number'
                        placeholder='Cantidad'
                        fullWidth
                        name='cantidad'
                        value={ cantidad }
                        onChange={ handleChangeInput }
                    />
                </Grid>

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        Ingresar Producto
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
